import { render, staticRenderFns } from "./ProdutoMonitoria.vue?vue&type=template&id=3f6477f8&scoped=true&"
import script from "./ProdutoMonitoria.vue?vue&type=script&lang=js&"
export * from "./ProdutoMonitoria.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoMonitoria.vue?vue&type=style&index=0&id=3f6477f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6477f8",
  null
  
)

export default component.exports